import React from 'react';
import classNames from 'classnames';

import { FONT_SIZES } from '../../../constants/font.constants';

export const Label = ({
  children,
  className = '',
  bold = false,
  italic = false,
  size = FONT_SIZES.MD,
  color = 'brand',
  ...rest
}) => (
  <span 
    className={classNames(`text-${color} text-${size}`, className, {
      'font-bold': bold,
      'italic': italic,
    })}
    {...rest}
  >
    { children }
  </span>
)

export default Label;
